import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import DataList from 'components/organisms/Lists/DataList/DataList';

const StyledFilesList = styled(DataList)`
  ${ComponentStyles}
`;

StyledFilesList.propTypes = {
  theme: PropTypes.object
};

export default StyledFilesList;
